import React, { forwardRef, useCallback, useState } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import FortifyMappingForm from './FortifyMappingForm';

const AUTH_TYPES_CONFIG = {
    clientAuth: 'clientAuth',
    userAuth: 'userAuth',
    tokenAuth: 'tokenAuth'
}

const FortifyCredentialsForm = forwardRef((props, ref) => {    
    const [authenticationType, setAuthType] = useState(() => {
        if(props.config){
            return props.config.client_id ? AUTH_TYPES_CONFIG.clientAuth : props.config.username  ? AUTH_TYPES_CONFIG.userAuth : AUTH_TYPES_CONFIG.tokenAuth;
        }
        return AUTH_TYPES_CONFIG.clientAuth;
    });

    const handleRadioChange = useCallback((e) => {
        setAuthType(e.target.value);
    },[]);

    const clientAuthFields = [{
        name: "client_id",
        label: "Client Id",
        props: {
            autoFocus: true
        },
        required: true
    }, {
        name: "client_secret",
        label: "Client Secret",
        type: FieldTypes.PASSWORD,
        required: true
    }]


    const userAuthFields =[{
        name: "tenantName",
        label: "Tenant Name",
    },{
        name: "username",
        label: "Username",
        required: true,
    },{
        name: "password",
        label: "Password / Token",
        required: true,
        type: FieldTypes.PASSWORD,
    }];

    const tokenAuthFields = [{
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
    }]


    const authFieled = authenticationType === AUTH_TYPES_CONFIG.userAuth ? userAuthFields : authenticationType === AUTH_TYPES_CONFIG.clientAuth ? clientAuthFields : tokenAuthFields;

    const fields = [
        {
            name: "apiEndpoint",
            label: "Fortify Endpoint",
            rules: [{
                required: true,
                message: "Endpoint is required"
            }, urlRegexValidator()]
        },
        {
            name: "authenticationType",
            type: FieldTypes.RADIO,
            options: [
                {
                    label: 'Client Auth',
                    value: AUTH_TYPES_CONFIG.clientAuth
                },
                {
                    label: 'User Auth',
                    value: AUTH_TYPES_CONFIG.userAuth
                },
                {
                    label: 'Token Auth',
                    value: AUTH_TYPES_CONFIG.tokenAuth
                }
            ],
            props: {
                onChange: handleRadioChange,
                defaultValue: authenticationType,
            }
        },
        ...authFieled,
    ];
    return (
        <GenericPullCredentialsForm 
         {...props} 
         ref={ref}
         fields={fields}
         MappingForm={FortifyMappingForm}
         initialValue={{ apiEndpoint: 'https://api.ams.fortify.com' }}
          />
    )
});

export default FortifyCredentialsForm;